import logEvent from './helpers/logEvent';
import setUserId from './helpers/setUserId';
import setUserProperties from './helpers/setUserProperties';

export * from './events';
export { setUserId, setUserProperties };
export default logEvent;
